import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import PostCard from "@/components/feature/PostCard";
import { getPostsByCategory } from "@/lib/content";

export default function CollectionSection() {
  const collection = getPostsByCategory("lezi");

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <SectionHeading
          eyebrow="WEEKLY COLLECTION"
          title="乐子合集"
          description="按周打包的轻松清单，不需要按顺序看，随手点开一条就能接住快乐。"
          actionLabel="进入乐子合集"
          actionTo="/category/lezi"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <div className="space-y-6">
              {collection.slice(0, 2).map((post) => (
                <PostCard key={post.id} post={post} variant="wide" />
              ))}
            </div>
          </div>

          <div className="flex flex-col rounded-xl2 border border-accent-200 bg-accent-50 p-6 lg:col-span-1">
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
              <i className="ri-gift-2-line text-2xl"></i>
            </span>
            <h3 className="mt-4 font-heading text-xl font-bold text-accent-950">一杯奶茶的快乐</h3>
            <p className="mt-3 text-sm leading-relaxed text-accent-900/85">
              我们把一天里最值得看的几条内容按心情排好序，从温和开机到高能收尾，你只需要跟着节奏点开就好。
            </p>
            <ul className="mt-5 space-y-3 text-sm text-accent-900">
              {[
                "周一：慢热型，帮你温和开机",
                "周三：中度笑点，撑过中段",
                "周五：最高能的一条，配合下班情绪",
              ].map((item) => (
                <li key={item} className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line mt-0.5 text-accent-600"></i>
                  <span className="leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
            <Link
              to="/category/lezi"
              className="mt-auto inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600"
            >
              打开本周清单
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}